// passing the path into variables

// const banner1 = '/assets/ivergrama/Home/Ivergrama-Website-Home-MainBanner1.jpg';

const banner1 = '/assets/ivergrama/Home/banner-concepcions.webp';
const banner2 = '/assets/ivergrama/Home/banner-puerto.webp';
const banner3 = '/assets/ivergrama/Home/banner-servicios.webp';


const destination1 =
	'/assets/ivergrama/Home/Ivergrama-Website-Destinations-DesktopVersion-Santiago-1.jpg';
const destination2 =
	'/assets/ivergrama/Home/Ivergrama-Website-Destinations-DesktopVersion-Temuco.jpg';
const destination3 =
	'/assets/ivergrama/Home/Ivergrama-Website-Destinations-DesktopVersion-PuertoSaavedra.jpg';
const destination4 =
	'/assets/ivergrama/Home/Ivergrama-Website-Destinations-DesktopVersion-Valdivia.jpg';
const destination5 =
	'/assets/ivergrama/Home/Ivergrama-Website-Destinations-DesktopVersion-Villarrica.jpg';
const destination6 =
	'/assets/ivergrama/Home/Ivergrama-Website-Destinations-DesktopVersion-Carahue.jpg';
const destination7 =
	'/assets/ivergrama/Home/Ivergrama-Website-Destinations-DesktopVersion-NuevaImperial.jpg';
const destination8 =
	'/assets/ivergrama/Home/Ivergrama-Website-Destinations-DesktopVersion-Santiago-2.jpg';

const service1 = '/assets/ivergrama/Home/puerto-saavedra-precio.png';
const service2 = '/assets/s';
const service3 = '/assets/ivergrama/Home/temuco-precio.png';
const service4 = '/assets/ivergrama/Home/nueva-imperial-precio.png';
const service5 = '/assets/ivergrama/Home/villarrica-precio-block.png';

const services = [service1, service2, service3, service4, service5];

const destination = [
	{ one: destination1, two: destination2, three: destination3, four: destination4 },

	{
		one: destination5,
		two: destination6,
		three: destination7,
		four: destination8,
	},
];


const banner = [banner1, banner2, banner3];


const ivergramaSlides = {
	banner,
	destination,
	services
};

export default ivergramaSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/ivergramaSlides.js